module.exports = __webpack_public_path__ + "img/tr.8a5f0ce1.svg";